export default "__VITE_ASSET__B4d7QDSB__"